import { useState } from "react";
import { Play, MessageCircle, CalendarCheck } from "lucide-react";

const VIDEO_ID = "2tVxGpbkcD4";
const MARGARITA_WA = "https://wa.me/19548059212?text=" + encodeURIComponent("Hola Margarita, vi el video en clubviajemos.com y quiero más información sobre los precios de agencia y cómo empezar.");
const WEBINAR_URL = "https://api.leadconnectorhq.com/widget/bookings/webinar-club-viajemos-24kgold?utm_source=home&utm_medium=video";

const HomePriceVideoSection = () => {
  const [playing, setPlaying] = useState(false);

  return (
    <section
      data-testid="home-price-video-section"
      className="bg-[#F6F8F3] py-16 sm:py-20 lg:py-24 px-4"
    >
      <div className="max-w-4xl mx-auto text-center">
        <h2
          className="font-black leading-tight text-[#00153F] text-3xl sm:text-4xl lg:text-5xl mb-4"
          style={{ fontFamily: "Poppins, sans-serif" }}
          data-testid="home-price-video-title"
        >
          El mismo hotel, las mismas fechas: $6,080 en internet o $2,813 con precio de agencia.
        </h2>
        <p className="text-slate-500 text-base sm:text-lg max-w-2xl mx-auto mb-10">
          Mira cómo funciona y descubre los 5 secretos de la industria del turismo que nadie te contó.
        </p>

        {/* Video 16:9 con facade (lazy load) */}
        <div className="mx-auto w-full max-w-[900px] mb-8">
          <div
            className="relative w-full rounded-[20px] overflow-hidden shadow-[0_18px_50px_rgba(0,21,63,0.18)] bg-black"
            style={{ aspectRatio: "16 / 9" }}
          >
            {playing ? (
              <iframe
                className="absolute inset-0 w-full h-full"
                src={`https://www.youtube.com/embed/${VIDEO_ID}?autoplay=1&rel=0`}
                title="Club Viajemos — Precio de agencia"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                data-testid="home-price-video-iframe"
              />
            ) : (
              <button
                type="button"
                onClick={() => setPlaying(true)}
                aria-label="Reproducir video"
                data-testid="home-price-video-play"
                className="group absolute inset-0 w-full h-full cursor-pointer"
              >
                <img
                  src={`https://img.youtube.com/vi/${VIDEO_ID}/maxresdefault.jpg`}
                  alt="El mismo hotel a precio de agencia — Club Viajemos"
                  className="absolute inset-0 w-full h-full object-cover"
                  loading="lazy"
                  onError={(e) => { e.currentTarget.src = `https://img.youtube.com/vi/${VIDEO_ID}/hqdefault.jpg`; }}
                />
                <span className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors" />
                <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-[#80C753] shadow-[0_8px_30px_rgba(128,199,83,0.6)] group-hover:scale-110 transition-transform">
                  <Play className="h-9 w-9 sm:h-11 sm:w-11 text-[#00153F] fill-[#00153F] ml-1" />
                </span>
              </button>
            )}
          </div>
        </div>

        {/* Botones */}
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 max-w-[900px] mx-auto">
          <a
            href={MARGARITA_WA}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="home-price-video-whatsapp"
            className="inline-flex items-center justify-center gap-2 min-h-[52px] px-6 rounded-xl bg-[#80C753] text-[#00153F] font-bold text-base hover:brightness-105 transition-all shadow-md"
          >
            <MessageCircle className="h-5 w-5" /> Hablar con Margarita por WhatsApp
          </a>
          <a
            href={WEBINAR_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="home-price-video-webinar"
            className="inline-flex items-center justify-center gap-2 min-h-[52px] px-6 rounded-xl bg-white border-2 border-[#45A0EE] text-[#45A0EE] font-bold text-base hover:bg-[#45A0EE]/5 transition-colors"
          >
            <CalendarCheck className="h-5 w-5" /> Reservar mi lugar en el webinar
          </a>
        </div>

        <p className="text-slate-400 text-xs sm:text-sm max-w-2xl mx-auto mt-6">
          Los ingresos no están garantizados; los ejemplos son ilustrativos y dependen del trabajo de cada agente.
        </p>
      </div>
    </section>
  );
};

export default HomePriceVideoSection;
